import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';
import ExcelJS from 'exceljs';

function Withholding() {
  const navigate = useNavigate();
  const [selectedMonth, setSelectedMonth] = useState(null);
  const [allData, setAllData] = useState([]);
  const [fileName, setFileNames] = useState([]);

  const handleMonthChange = (e) => {
    setSelectedMonth(parseInt(e.target.value, 10));
  };

  const handleFileUpload = async (e) => {
    const files = e.target.files;
    if (!files) return;
    const fileArray = Array.from(files);
    setFileNames(fileArray.map((file) => file.name.split('.')[0]));

    const dataPromises = fileArray.map(
      (file) =>
        new Promise((resolve) => {
          const reader = new FileReader();
          reader.onload = (event) => {
            const binaryStr = event.target.result;
            const workbook = XLSX.read(binaryStr, { type: 'binary' });
            const sheetName = workbook.SheetNames[0];
            const worksheet = workbook.Sheets[sheetName];
            const jsonData = XLSX.utils.sheet_to_json(worksheet, { header: 1 });
            resolve(jsonData);
          };
          reader.readAsBinaryString(file);
        })
    );
    const allFileData = await Promise.all(dataPromises);
    setAllData(allFileData);
  };

  const createNewExcelWithDayAndName = () => {
    if (selectedMonth === null) {
      alert('월을 선택해주세요.');
      return;
    }

    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet('업무일자');

    const headerRow = [
      '보험구분',
      '성명',
      '주민(외국인)등록번호',
      '신고월',
      '직종코드',
      ...Array.from({ length: 31 }, (_, i) => `${i + 1}일`),
      '근로일수',
      '일평균근로시간',
      '보수기초일수',
      '보수총액',
      '임금총액',
      '이직사유코드',
      '보험료부과구분부호',
      '보험료부과구분사유',
      '국세청신고여부',
      '지급월',
      '총지급액',
      '비과세소득',
      '소득세',
      '지방소득세',
    ];
    const row = worksheet.addRow(headerRow);
    row.eachCell((cell) => {
      cell.font = { bold: true };
      cell.alignment = { vertical: 'middle', horizontal: 'center', wrapText: true };
      cell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'D3D3D3' } };
    });
    worksheet.columns = headerRow.map(() => ({ width: 15 }));
    worksheet.getRow(1).height = 50;
    worksheet.views = [{ state: 'frozen', ySplit: 1, xSplit: 4 }];

    const fileDataMap = {},
      신고월Map = {},
      deliveryFeeMap = {};

    allData.forEach((fileData, fileIndex) => {
      const currentFile = fileName[fileIndex];
      fileDataMap[currentFile] = new Array(31).fill('');
      신고월Map[currentFile] = '';
      deliveryFeeMap[currentFile] = 0;

      const deliveryFeeIndex = fileData[0]?.indexOf('배달요금') ?? -1;

      fileData.forEach((rowData) => {
        const 업무일자셀 = rowData.find(
          (cell) => typeof cell === 'string' && cell.includes('업무일자:')
        );
        if (업무일자셀) {
          const 업무일자 = 업무일자셀.split('업무일자:')[1]?.trim();
          const month = parseInt(업무일자.slice(4, 6), 10);
          const day = parseInt(업무일자.slice(-2), 10);
          if (month === selectedMonth && day >= 1 && day <= 31) {
            fileDataMap[currentFile][day - 1] = 1;
            신고월Map[currentFile] = 업무일자.slice(0, 6);
          }
        }

        if (deliveryFeeIndex !== -1) {
          const fee = parseFloat(rowData[deliveryFeeIndex]);
          if (!isNaN(fee)) deliveryFeeMap[currentFile] += fee;
        }
      });
    });

    Object.keys(fileDataMap).forEach((file) => {
      const totalSum = fileDataMap[file].reduce(
        (sum, val) => sum + (typeof val === 'number' ? val : 0),
        0
      );
      worksheet
        .addRow([
          5,
          file,
          '',
          신고월Map[file],
          982,
          ...fileDataMap[file],
          totalSum,
          '',
          totalSum,
          deliveryFeeMap[file],
          '',
          '',
          57,
          26,
          '',
          '',
          '',
          '',
          '',
          '',
        ])
        .eachCell((cell) => (cell.alignment = { vertical: 'middle', horizontal: 'center' }));
    });

    workbook.xlsx.writeBuffer().then((buffer) => {
      const blob = new Blob([buffer], {
        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      });
      saveAs(blob, '업무일자.xlsx');
    });
  };

  return (
    <div className="p-4">
      <button onClick={() => navigate('/')}>메인 페이지 이동</button>
      <h1>근무 날짜 계산 페이지</h1>
      <select value={selectedMonth || ''} onChange={handleMonthChange}>
        <option value="">월 선택</option>
        {Array.from({ length: 12 }, (_, i) => (
          <option key={i + 1} value={i + 1}>
            {i + 1}월
          </option>
        ))}
      </select>
      <input type="file" accept=".xlsx, .xls" multiple onChange={handleFileUpload} />
      <button onClick={createNewExcelWithDayAndName}>엑셀 생성</button>
    </div>
  );
}

export default Withholding;
